import { Button, Text } from '@pairy/pds-react';
import styled from '@emotion/styled';
import { theme } from '@pairy/styles';

export const SelectButton = styled(Button)`
  &.is-active {
    background-color: ${theme.colors.black};
    color: ${theme.colors.white};
  }

  & > div {
    word-break: keep-all;
  }
`;

export const KeepAllText = styled(Text)`
  word-break: keep-all;
`;
